//Get age from date of birth
import { PLAN_ID, umpeso } from './constanst';

export const getDateFronIdentity = identity => {

    if (String(identity).length != 16) return null;

    const fecNac = identity.split("-")[1];

    let dia = fecNac.substr(0, 2);
    let mes = fecNac.substr(2, 2);
    let año = fecNac.substr(4, 2);

    let añoActualFecha = new Date().getFullYear().toString();

    let añoActualPrimerosDos = añoActualFecha.substr(0, 2);
    let añoAnteriorPrimerosDos = añoActualPrimerosDos - 1;

    let añoAnterior = añoAnteriorPrimerosDos + año;
    let añoActual = añoActualPrimerosDos + año;

    let añoAplicar = "";
    if (añoActualFecha < añoActual) {
        añoAplicar = añoAnterior;
    } else {
        añoAplicar = añoActual;
    }

    return new Date(añoAplicar, mes - 1, dia);

    //$("#peFnacimiento").val(dia + "-" + mes + "-" + añoAplicar).trigger("change");

}

const calculateAge = date => {

    const today = new Date();
    const birthDate = new Date(date);

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return {
        age,
        birthDate
    };

}


export const getAge = date => {

    let { age } = calculateAge(date);
    
    return age;

}

export const getAgeActuarial = date => {

    const today = new Date();

    let { age, birthDate } = calculateAge(date);

    const diff = today - birthDate;

    const dias = Math.floor(diff / 86400000);
    let edadDec = dias / 365.25;
    edadDec = edadDec - age;

    if (edadDec >= 0.5) age++;

    return age;

}

//get IMC
export const getIMC = (weight, height) => {
    return parseFloat(weight / (height * height)).toFixed(2);
}

export const getIMCWithInfo = (weight, height, { unidaPeso = umpeso.kgs }) => {

    let _weight = '';

    if (unidaPeso === umpeso.lbrs)  //lbs
        _weight = parseFloat(weight / 2.20462).toFixed(2);


    return getIMC(_weight, +height);
}

//gereta uuid
export const getUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const round = num => Math.round((parseFloat(num) + 0.00001) * 100) / 100

export const twoDecimal = (value) => parseFloat(value).toFixed(2);

export const mapData = poliza => {

    const getProperty = property => poliza[property];

    return {
        //"documentos": getProperty('files'),
        "Id": getProperty('id'),
        "Plan": PLAN_ID,
        "Frecuencia": getProperty('frecuenciaPagos'),
        "itipopol": "I",
        "SA": getProperty('sa'),
        "Prima": getProperty('prima'),
        "Descuento": 0.0,
        "PrimaNeta": getProperty('prima'),
        "DerechoEmision": 0.0,
        "Impuesto": 0.0,
        "Total": getProperty('prima'),
        "clausulaArbitraje":getProperty('clausulaArbitraje'),
        "Asegurado":
        {
            "TipoId": getProperty('tipoId'),
            "NumId": getProperty('identificacion'),
            "Nombre": getProperty('nombres'),
            "Apellido": getProperty('apellidos'),
            "EstadoCivil": getProperty('estadoCivil'),
            "FechaNacimiento": getProperty('fechaNacimiento'),
            "Profesion": getProperty('profesion'),
            "Ocupacion": getProperty('ocupacion'),
            "Sexo": getProperty('sexo'),
            "Actividad": getProperty('actividad'),
            "OrigenFondos": getProperty('origenFondo'),
            "OrigenFondosDetalle": getProperty('origenFondoOtros'),
            "Direccion": getProperty('direccion'),
            "Departamento": getProperty('departamento'),
            "Municipio": getProperty('municipio'),
            "TelefonoCasa": getProperty('telefonoCasa'),
            "TelefonoCelular": getProperty('telefonoCelular'),
            "Email": getProperty('email'),
            "CasaPropia": getProperty('hasHouse'),
            "TieneHijos": getProperty('hasChildren'),
            "VehiculoPropio": getProperty('hasCar'),
            "Pais":getProperty('pais'),
            "NombreEmp": getProperty('empresaTrabaja'),
            "TelefonoEmp": getProperty('telefono'),
        },
        "Oa": {
            "SA": getProperty('sa'),
            "peFnacimiento": getProperty('fechaNacimiento'),
            "peIngreso": getProperty('ingresoMensual'),
            "peIngresoMoneda": getProperty('ingresoMoneda'),
            "peEstatura": getProperty('estatura'),
            "peEstaturaUnidades": getProperty('estaturaUnidades'),
            "pePeso": getProperty('peso'),
            "pePesoUnidades": getProperty('pesoUnidades'),
            "peImc": getProperty('imc'),
            "peZurdo": !getProperty('lateralidad'),
            "peActividad": getProperty('actividad'),

            "peEdadAct": getProperty('edad'),
        },
        "Beneficiarios": convertToBenes(poliza, getProperty('beneficiarios')),
        "PolCobs": convertToPolCobs(getProperty('polCobs')),
        "Respuesta": convertToRespuesta(getProperty('questions')),
        "FormaPagos": convertToFormaPagos(poliza)
    }

}

const convertToFormaPagos = p => {


    let ano = '';
    let mes = '';
    if (p.fechaExpiracion !== '') {
        let split = p.fechaExpiracion.split('/');
        mes = split[0];
        ano = `20${split[1]}`;
    }

    return {
        forma: '',
        ref: '',
        nombre: p.nombreTarjeta,
        numero: p.numeroTarjeta,
        tipo: '',
        VtoMes: mes,
        VtoAnio: ano,
        Emisor: '',
        Autorizacion: '',
        Cuotas: parseInt(p.frecuenciaPagos),
        Frecuencia: p.frecuenciaPagos,
        Monto: p.prima,
        Poliza_Id: p.id,
        banco: '',
        tarjeta: '',
        MonedaPago: p.pagoMoneda,
        PagoDirectoTarjeta: 1,
    }
};

const convertToPolCobs = polCobs => {

    return polCobs.map(cob => {

        return {
            "Id": 0,
            "IdCob": cob.idCob,
            "Nombre": `Cobertura ${cob.idCob}`,
            "SA": cob.sa,
            "COA": cob.coa,
            "Deducible": cob.deducible,
            "Prima": cob.prima,
            "PolizaId": 0,
            "cia": null,
            "ptasa": cob.pTasa,
            "pdescuento": 0.0,
            "mdescuento": 0.0,
            "mprimabruta": cob.prima,
            "PrimaGravada": 0.0,
            "orden": 1,
            "inSA": "0",
            "inCGRUPO": null,
            "inCGRUPO1": null,
            "inCGRUPO2": null,
            "bDescuentoManual": false,
            "pRecargo": cob.pRecargo,
            "mRecargo": cob.mRecargo,
            "pComision": cob.pComision,
            "mComision": 0,
            "Etiqueta": "0",
            "PrimaDE": cob.prima,
        }

    })

}

const convertToRespuesta = (questions) => {

    let respuestas = [];

    questions.forEach(question => {
        let respuesta = {
            "Id": 0,
            "PolizaId": 0,
            "PreguntaId": question.id,
            "Orden": question.orden,
            "TipoResp": question.tipo,
            "Respuestas": question.tipo === 0 ? question.value : false,
            "cia": 1,
            "Texto": question.tipo === 1 ? question.text : null,
        }
        respuestas.push(respuesta);
    });

    return respuestas;

}

const convertToBenes = (poliza, beneficiarios) => {

    //console.log(beneficiarios);

    return beneficiarios.map(beneficiario => {

        return {
            "Id": 0,
            "PolizaId": 0,
            "nombre": beneficiario.nombres,
            "parentesco": beneficiario.parentesco,
            "xparentesco": "",
            "participacion": beneficiario.porcentaje,
            "cedula": '',
            "menor": false,
            "repLegal": poliza.nombreRepresentante,
            "xcedulaRepresentante": poliza.cedulaRepresentante,
            "cia": 1,
            "bprincipal": false,
            "direccion": '',
            "cpais": '0',
            "cestado": '0',
            "cciudad": '0',
            "Nacionalidad": '0',
            "Sexo": '',
            "fnacimien": null,
            "itipobenef": '0'
        };

    });

}


export const removeLoading=()=>{
    setTimeout(() => {
        const preloader = document.querySelector('.site-preloader');

        if (preloader) {
            preloader.addEventListener('transitionend', (event) => {
                if (event.propertyName === 'opacity') {
                    preloader.parentNode.removeChild(preloader);
                }
            });
            preloader.classList.add('site-preloader__fade');
        }
    }, 200);
};